import localSave from '@utils/local-save'

const STORAGE_KEY = 'libraryRecentSearches'
const MAX_ITEMS = 5

const sameItem = (a, b) => a.type === b.type && a.id === b.id

function read() {
    const stored = localSave.get(STORAGE_KEY)
    return Array.isArray(stored) ? stored : []
}

export default {
    getRecent() {
        return read()
    },
    addToRecent(item) {
        const items = [...read().filter(el => !sameItem(el, item)), item].slice(-MAX_ITEMS)
        localSave.save(STORAGE_KEY, items)
        return items
    },
    removeFromRecent(item) {
        const items = read().filter(el => !sameItem(el, item))
        localSave.save(STORAGE_KEY, items)
        return items
    },
    clearRecent() {
        localSave.save(STORAGE_KEY, [])
    },
}
